"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.socket = void 0;
var connection_1 = require("./connection");
Object.defineProperty(exports, "socket", { enumerable: true, get: function () { return connection_1.socket; } });
